import { LocalStorageCodes } from '../../../core/codes';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
//import { Observable } from 'rxjs/Observable';
//import { AppSettings } from '../../../config/app-settings';
@Injectable()
export class LocalShoppingItemsData {
    constructor(private storage: Storage) {

    }
    public get() {
        return this.storage.get('strg:shopping-items/SnTClbm0IhVNORPO2vHerhnlucr1').then(result => {
            console.log(result);
        });

    }
    public set(userId, shoppingItems): Promise<any> {
        return this.search().then(localShoppingItems => {
            let strgRef = LocalStorageCodes.SHOPPING_ITEMS + '/' + userId;

            if (!localShoppingItems) {
                localShoppingItems = {};
            }
            localShoppingItems = shoppingItems;

            console.log(localShoppingItems);
            return this.storage.set(strgRef, JSON.stringify(localShoppingItems)).then(result => {
                console.log(result);

            });
        });
    }
    public search(uid?) {
        let strgRef = LocalStorageCodes.SHOPPING_ITEMS + '/' + uid;
        return this.storage.get(strgRef).then(function (value) {
            console.log(JSON.parse(value), uid);
            if (value) {
                var result = JSON.parse(value);
            }
            return result ? result : null;
        });
    }
    public add(userId, itemKey, shoppingItemData): Promise<any> {
        return this.search(userId).then(localShoppingItems => {
            let strgRef = LocalStorageCodes.SHOPPING_ITEMS + '/' + userId;
            if (!localShoppingItems || localShoppingItems.constructor === Array) {
                localShoppingItems = {};
            }
            if (!itemKey) {
                itemKey = this._genKey();
            }
            shoppingItemData['$key'] = itemKey;
            localShoppingItems[itemKey] = shoppingItemData;
            console.log(localShoppingItems);
            return this.storage.set(strgRef, JSON.stringify(localShoppingItems)).then(() => {
                return shoppingItemData;
            });
        });
    }
    public remove(userId, itemKey): Promise<any> {
        return this.search(userId).then(localShoppingItems => {
            let strgRef = LocalStorageCodes.SHOPPING_ITEMS + '/' + userId;
            if (!localShoppingItems || localShoppingItems.constructor === Array) {
                localShoppingItems = {};
            }
            delete localShoppingItems[itemKey];
            console.log(localShoppingItems, itemKey);
            return this.storage.set(strgRef, JSON.stringify(localShoppingItems));
        });
    };
    public _genKey() {
        var length = 8,
            timestamp = +new Date;

        var _getRandomInt = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        var ts = timestamp.toString();
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < length; ++i) {
            var index = _getRandomInt(0, parts.length - 1);
            id += parts[index];
        }
        return id;
    }

}


// WEBPACK FOOTER //
// ./src/modules/account/providers/local-shopping-items-data.ts